import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsHeaderComponent } from './components/cms-header/cms-header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

import { NgIconsModule } from '@ng-icons/core';
import * as icons from '@ng-icons/heroicons/outline';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { CardStatsComponent } from './components/card-stats/card-stats.component';
import { UserDropdownComponent } from './components/cms-header/components/user-dropdown/user-dropdown.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderStatsComponent } from './components/header-stats/header-stats.component';

import { ToastrModule } from 'ngx-toastr';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';

@NgModule({
  declarations: [
    CmsHeaderComponent,
    SidebarComponent,
    PageTitleComponent,
    MainLayoutComponent,
    CardStatsComponent,
    UserDropdownComponent,
    FooterComponent,
    HeaderStatsComponent,
    PageHeaderComponent,
    ConfirmationModalComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    NgIconsModule.withIcons(icons),
    ToastrModule.forRoot(),
  ],
  exports: [
    CmsHeaderComponent,
    SidebarComponent,
    NgIconsModule,
    PageTitleComponent,
    ConfirmationModalComponent,
    CardStatsComponent,
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
